import { ECourseTabEnum } from '../enum/e-course-tab-enum'

export const getNextTab = (tab: ECourseTabEnum) => {
  const tabs = [
    ECourseTabEnum.thumbnail,
    ECourseTabEnum.course,
    ECourseTabEnum.checkout,
    ECourseTabEnum.thank_you,
    ECourseTabEnum.options,
  ]

  const currentTabIndex = tabs.indexOf(tab)

  return tabs[currentTabIndex + 1]
}
